module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation6.0fe64a7c.png";